import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[vfsPercentage]'
})
export class PercentageDirective implements OnInit {
  /** The minimum number of integer digits before the decimal point. */
  @Input() minIntegerDigits: number | string = 1;
  /** The minimum number of digits after the decimal point. */
  @Input() minFractionDigits: number | string = 0;
  /** The maximum number of digits after the decimal point. */
  @Input() maxFractionDigits: number | string = 3;
  regex: RegExp;
  specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    '-',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Delete'
  ];

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.regex = new RegExp(
      `(^100(.0{1,2})?$)|(^([1-9]([0-9])?|0)(.[0-9]{${this.minFractionDigits},${this.maxFractionDigits}})?$)`
    );
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (
      next &&
      (!String(next).match(this.regex) || parseFloat(next) < 0 || parseFloat(next) > 100 || event.key === ',')
    ) {
      event.preventDefault();
    }
  }
}
